import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Configuring your JAMStack app for prod vs. dev",
  "description": "",
  "published": "2020-03-26T00:00:00.000Z",
  "redirect_from": ["/blog/configuring-your-jamstack-app-for-prod-vs-dev/swizec/9357"],
  "categories": "Back End, Front End, Technical",
  "hero": "./img/techletter.app-screenshot-1585240252506.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`You should always keep development and production separate my friend, but how do you pull that off when everyone has your back and tries to keep your app secure?`}</p>
    <p>{`wait what 🤨`}</p>
    <p>{`Here's the problem 👉`}</p>
    <p>{`You've built a cool app. Static JAM on the frontend, Serverless functions on the backend, nearly free to host, super fast to load. It's amazing and you're proud as heck.`}</p>
    <p>{`Time to show off!`}</p>
    <p><img parentName="p" {...{
        "src": "/e14ff3533106667d5a36adcdc2fedaec/media-QugrBeDxEFuDfooN11-giphy.gif",
        "alt": "show_off giphy"
      }}></img></p>
    <p>{`You know dev and production should be separate. Wouldn't want users to see a bug next time you mess around with code. Sure as heck don't want to mix test and production data.`}</p>
    <h2 {...{
      "id": "prod-vs-dev-on-your-serverless-backend"
    }}>{`Prod vs. Dev on your serverless backend`}</h2>
    <p>{`Separating development and production on your backend is easy as pie. Change the `}<inlineCode parentName="p">{`stage:`}</inlineCode>{` in serverless.yml and voila.`}</p>
    <p>{`Using the demo app from `}<a parentName="p" {...{
        "href": "https://serverlessreact.dev"
      }}>{`ServerlessReact.Dev`}</a>{` for example:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=yaml&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=service%3A%20markdownlandingpage%0A%0Aprovider%3A%0A%20%20%20%20name%3A%20aws%0A%20%20%20%20runtime%3A%20nodejs12.x%0A%20%20%20%20stage%3A%20dev%20%23%20this%20is%20the%20important%20bit%0A%20%20%20%20environment%3A%0A%20%20%20%20%20%20%20%20USER_TABLE%3A%20%24%7Bself%3Aservice%7D-users-%24%7Bself%3Aprovider.stage%7D%0A%0Afunctions%3A%0A%20%20%20%20graphql%3A%0A%20%20%20%20%20%20%20%20handler%3A%20dist%2Fgraphql.handler%0A%20%20%20%20%20%20%20%20events%3A%0A%20%20%20%20%20%20%20%20%20%20%20%20-%20http%3A%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20path%3A%20graphql%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20method%3A%20GET%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20cors%3A%20true%0A%20%20%20%20%20%20%20%20%20%20%20%20-%20http%3A%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20path%3A%20graphql%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20method%3A%20POST%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20cors%3A%20true%0A%0Aresources%3A%0A%20%20%20%20Resources%3A%0A%20%20%20%20%20%20%20%20UsersTable%3A%0A%20%20%20%20%20%20%20%20%20%20%20%20Type%3A%20%22AWS%3A%3ADynamoDB%3A%3ATable%22%0A%20%20%20%20%20%20%20%20%20%20%20%20Properties%3A%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20AttributeDefinitions%3A%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20-%20AttributeName%3A%20userId%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20AttributeType%3A%20S%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20KeySchema%3A%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20-%20AttributeName%3A%20userId%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20KeyType%3A%20HASH%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20ProvisionedThroughput%3A%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20ReadCapacityUnits%3A%201%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20WriteCapacityUnits%3A%201%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20TableName%3A%20%24%7Bself%3Aprovider.environment.USER_TABLE%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "630px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "132.7354260089686%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'530\\'%20viewBox=\\'0%200%20400%20530\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M22%2032c-2%201-2%2024-2%20233l1%20234c1%202%20357%202%20358%200l1-234c0-209%200-232-2-233-2-3-354-3-356%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/61005385130339187a47835490fe5437/ca0a1/techletter.app-screenshot-1585240252506.webp 223w", "/static/61005385130339187a47835490fe5437/75680/techletter.app-screenshot-1585240252506.webp 445w", "/static/61005385130339187a47835490fe5437/8aab1/techletter.app-screenshot-1585240252506.webp 630w"],
                "sizes": "(max-width: 630px) 100vw, 630px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/61005385130339187a47835490fe5437/e92b6/techletter.app-screenshot-1585240252506.png 223w", "/static/61005385130339187a47835490fe5437/e66bf/techletter.app-screenshot-1585240252506.png 445w", "/static/61005385130339187a47835490fe5437/f058b/techletter.app-screenshot-1585240252506.png 630w"],
                "sizes": "(max-width: 630px) 100vw, 630px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/61005385130339187a47835490fe5437/f058b/techletter.app-screenshot-1585240252506.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`This configures a `}<inlineCode parentName="p">{`/graphql`}</inlineCode>{` endpoint served by an AWS Lambda and a DynamoDB table to store your data. Both the DynamoDB table and the GraphQL endpoint use stage as part of their name.`}</p>
    <p>{`Change that to `}<inlineCode parentName="p">{`stage: dev`}</inlineCode>{` to `}<inlineCode parentName="p">{`stage: prod`}</inlineCode>{`, run `}<inlineCode parentName="p">{`yarn deploy`}</inlineCode>{`, and you get a whole new copy of your backend infrastructure. A new AWS Lambda, new DynamoDB table, everything.`}</p>
    <p><img parentName="p" {...{
        "src": "/d8a715082cbc8cae4dc520e5d2fbb45a/media-l3q2LH45XElELRzRm-giphy.gif",
        "alt": "perfect giphy"
      }}></img></p>
    <h3 {...{
      "id": "making-your-stage-easy-to-change"
    }}>{`Making your stage easy to change`}</h3>
    <p>{`Changing serverless.yml on deploy is tedious. You'll commit the wrong version to git, too.`}</p>
    <p>{`Define your stage with command line arguments instead!`}</p>
    <p>{`Like this:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=yaml&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=provider%3A%0A%20%20%20%20stage%3A%20%24%7Bopt%3Astage%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "286px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "71.74887892376681%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'287\\'%20viewBox=\\'0%200%20400%20287\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M47%2071c-2%202-2%203-2%2074%200%2076%200%2073%205%2076%203%202%20298%202%20301%200%205-3%205%200%205-76%200-71%200-72-2-74l-2-3H49l-2%203m50%2021c-4%204-3%209%201%2012%205%203%2013-1%2013-7%200-7-10-11-14-5m30-2c-7%203-5%2013%203%2015%207%201%2011-8%206-14-3-2-5-2-9-1m167%2085v9l4%201c2%200%202%200%201%202l-3%201h-2l3%201c4%200%205-3%205-10%200-4-1-5-4-5l-4%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/b9909bcb99a00687eefc80819646cbe8/ca0a1/techletter.app-screenshot-1585240252762.webp 223w", "/static/b9909bcb99a00687eefc80819646cbe8/4430b/techletter.app-screenshot-1585240252762.webp 286w"],
                "sizes": "(max-width: 286px) 100vw, 286px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/b9909bcb99a00687eefc80819646cbe8/e92b6/techletter.app-screenshot-1585240252762.png 223w", "/static/b9909bcb99a00687eefc80819646cbe8/357e3/techletter.app-screenshot-1585240252762.png 286w"],
                "sizes": "(max-width: 286px) 100vw, 286px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/b9909bcb99a00687eefc80819646cbe8/357e3/techletter.app-screenshot-1585240252762.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Now you can add a helpful little bash script – because I couldn't figure out how to do this with Node and Bash is just fine. 😇`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=bash&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%23%20deploy.sh%0A%0ASTAGE%3D%24%7B1%3A-dev%7D%0Ayarn%20build%0ANODE_ENV%3D%24STAGE%20sls%20deploy%20--stage%20%24STAGE"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "430px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "60.0896860986547%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'241\\'%20viewBox=\\'0%200%20400%20241\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M31%2046c-2%202-1%20148%201%20150s334%202%20336%200%203-148%201-150-336-2-338%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/7b26732f0d8bac15afac8226ca43e92a/ca0a1/techletter.app-screenshot-1585240252694.webp 223w", "/static/7b26732f0d8bac15afac8226ca43e92a/866c5/techletter.app-screenshot-1585240252694.webp 430w"],
                "sizes": "(max-width: 430px) 100vw, 430px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/7b26732f0d8bac15afac8226ca43e92a/e92b6/techletter.app-screenshot-1585240252694.png 223w", "/static/7b26732f0d8bac15afac8226ca43e92a/05ed2/techletter.app-screenshot-1585240252694.png 430w"],
                "sizes": "(max-width: 430px) 100vw, 430px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/7b26732f0d8bac15afac8226ca43e92a/05ed2/techletter.app-screenshot-1585240252694.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Add to your `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` ...`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=json&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%20%20%20%20%22scripts%22%3A%20%7B%0A%20%20%20%20%20%20%20%20%22deploy%22%3A%20%22sh%20deploy.sh%22%0A%20%20%20%20%7D%2C"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "358px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "62.33183856502242%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'249\\'%20viewBox=\\'0%200%20400%20249\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M38%2056c-2%202-2%203-2%2070v68l3%202c4%202%20319%202%20323%200l3-2v-68c0-67%200-68-2-70-3-3-322-3-325%200m40%2017c-4%204-1%2011%204%2011%203%200%207-4%207-6%200-6-8-9-11-5m24-1c-7%204-2%2015%205%2011%204-2%205-6%202-10-3-2-5-2-7-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/3dbc94a4b6beb57e2c6f973cea31366c/ca0a1/techletter.app-screenshot-1585240252676.webp 223w", "/static/3dbc94a4b6beb57e2c6f973cea31366c/44bcf/techletter.app-screenshot-1585240252676.webp 358w"],
                "sizes": "(max-width: 358px) 100vw, 358px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/3dbc94a4b6beb57e2c6f973cea31366c/e92b6/techletter.app-screenshot-1585240252676.png 223w", "/static/3dbc94a4b6beb57e2c6f973cea31366c/39185/techletter.app-screenshot-1585240252676.png 358w"],
                "sizes": "(max-width: 358px) 100vw, 358px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/3dbc94a4b6beb57e2c6f973cea31366c/39185/techletter.app-screenshot-1585240252676.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`And you can run `}<inlineCode parentName="p">{`yarn deploy prod`}</inlineCode>{` to deploy to production, or `}<inlineCode parentName="p">{`yarn deploy`}</inlineCode>{` to get development by default.`}</p>
    <p>{`Wonderful.`}</p>
    <h2 {...{
      "id": "prod-vs-dev-on-your-jamstack-frontend"
    }}>{`Prod vs. Dev on your JAMStack frontend`}</h2>
    <p>{`Separating production and development on the JAM is easy in theory 👉 push to a branch and you get a deploy preview. Press a button or push to a special branch and you get production.`}</p>
    <p>{`Both Netlify and Zeit do that. I'm sure others do, too.`}</p>
    <p>{`That was easy.`}</p>
    <p>{`Now, how do you tell your app that production data lives on `}<inlineCode parentName="p">{`...amazonaws.com/prod/graphql`}</inlineCode>{` and development should talk to `}<inlineCode parentName="p">{`...amazonaws.com/dev/graphql`}</inlineCode>{`?`}</p>
    <p><img parentName="p" {...{
        "src": "/05ebc988bb8c4f0f0a6eda250d802709/media-26n7brbdOADCBDfUs-giphy-downsized-medium.gif",
        "alt": "think_hard giphy"
      }}></img></p>
    <p>{`That's where it gets tricky.`}</p>
    <p>{`I've found 3 approaches with varying levels of success and different tradeoffs.`}</p>
    <h3 {...{
      "id": "1-the-gatsby-way"
    }}>{`1. The Gatsby way`}</h3>
    <p>{`Gatsby comes with `}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.org/docs/environment-variables/"
      }}>{`built-in support for `}<inlineCode parentName="a">{`.env`}</inlineCode>{` files`}</a>{`. Put your environment variables in `}<inlineCode parentName="p">{`.env.development`}</inlineCode>{` or `}<inlineCode parentName="p">{`.env.production`}</inlineCode>{`, access through `}<inlineCode parentName="p">{`process.env`}</inlineCode>{` and let Gatsby handle the rest.`}</p>
    <p>{`Say you want to tell Gatsby which GraphQL endpoint to use when building your JAMStack app.`}</p>
    <p>{`Go in `}<inlineCode parentName="p">{`gatsby-config.js`}</inlineCode>{` and add your server as a source`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20gatsby-config.js%0A%0A%2F%2F%20load%20the%20appropriate%20.env.X%20file%0Arequire(%22dotenv%22).config(%7B%0A%20%20path%3A%20%60.env.%24%7Bprocess.env.NODE_ENV%7D%60%2C%0A%7D)%0A%0A%2F%2F%20your%20config%0A%2F%2F%20..%0A%20%20plugins%3A%20%5B%0A%20%20%20%20%7B%0A%20%20%20%20%20%20resolve%3A%20%22gatsby-source-graphql%22%2C%0A%20%20%20%20%20%20options%3A%20%7B%0A%20%20%20%20%20%20%20%20typeName%3A%20%22MDLAPI%22%2C%0A%20%20%20%20%20%20%20%20fieldName%3A%20%22mdlapi%22%2C%0A%20%20%20%20%20%20%20%20url%3A%20process.env.GATSBY_GRAPHQL_URL%2C%0A%20%20%20%20%20%20%7D%2C%0A%20%20%20%20%7D%2C"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "454px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "108.5201793721973%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'434\\'%20viewBox=\\'0%200%20400%20434\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M30%2044c-3%202-3%20345%200%20347%202%203%20338%203%20340%200%203-3%203-345%200-347-3-3-338-3-340%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/f7f7f67cd741eb596c1322a86ae2459a/ca0a1/techletter.app-screenshot-1585240253005.webp 223w", "/static/f7f7f67cd741eb596c1322a86ae2459a/75680/techletter.app-screenshot-1585240253005.webp 445w", "/static/f7f7f67cd741eb596c1322a86ae2459a/44d9f/techletter.app-screenshot-1585240253005.webp 454w"],
                "sizes": "(max-width: 454px) 100vw, 454px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/f7f7f67cd741eb596c1322a86ae2459a/e92b6/techletter.app-screenshot-1585240253005.png 223w", "/static/f7f7f67cd741eb596c1322a86ae2459a/e66bf/techletter.app-screenshot-1585240253005.png 445w", "/static/f7f7f67cd741eb596c1322a86ae2459a/b3c1d/techletter.app-screenshot-1585240253005.png 454w"],
                "sizes": "(max-width: 454px) 100vw, 454px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/f7f7f67cd741eb596c1322a86ae2459a/b3c1d/techletter.app-screenshot-1585240253005.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`You can now configure the `}<inlineCode parentName="p">{`GATSBY_GRAPHQL_URL`}</inlineCode>{` environment variable in 2 files to differentiate production and development.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=null&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20.env.development%0AGATSBY_GRAPHQL_URL%3Dhttps%3A%2F%2F...%2Fdev%2Fgraphql"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "438px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "46.63677130044843%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'187\\'%20viewBox=\\'0%200%20400%20187\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M30%2046v96c2%203%2015%203%20170%203s168%200%20170-3V46c-2-3-338-3-340%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/b8da6de109e11e75f533a2a2339717c9/ca0a1/techletter.app-screenshot-1585240252667.webp 223w", "/static/b8da6de109e11e75f533a2a2339717c9/4a74f/techletter.app-screenshot-1585240252667.webp 438w"],
                "sizes": "(max-width: 438px) 100vw, 438px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/b8da6de109e11e75f533a2a2339717c9/e92b6/techletter.app-screenshot-1585240252667.png 223w", "/static/b8da6de109e11e75f533a2a2339717c9/50e4b/techletter.app-screenshot-1585240252667.png 438w"],
                "sizes": "(max-width: 438px) 100vw, 438px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/b8da6de109e11e75f533a2a2339717c9/50e4b/techletter.app-screenshot-1585240252667.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=null&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20.env.production%0AGATSBY_GRAPHQL_URL%3Dhttps%3A%2F%2F...%2Fprod%2Fgraphql"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "446px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "45.73991031390135%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'184\\'%20viewBox=\\'0%200%20400%20184\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M30%2044l-1%2049c0%2045%200%2047%202%2048h338c2-1%202-3%202-48l-1-49c-2-2-338-2-340%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/34f9d41cef976faa397e17e7bf9846be/ca0a1/techletter.app-screenshot-1585240252713.webp 223w", "/static/34f9d41cef976faa397e17e7bf9846be/75680/techletter.app-screenshot-1585240252713.webp 445w", "/static/34f9d41cef976faa397e17e7bf9846be/5021b/techletter.app-screenshot-1585240252713.webp 446w"],
                "sizes": "(max-width: 446px) 100vw, 446px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/34f9d41cef976faa397e17e7bf9846be/e92b6/techletter.app-screenshot-1585240252713.png 223w", "/static/34f9d41cef976faa397e17e7bf9846be/e66bf/techletter.app-screenshot-1585240252713.png 445w", "/static/34f9d41cef976faa397e17e7bf9846be/6244b/techletter.app-screenshot-1585240252713.png 446w"],
                "sizes": "(max-width: 446px) 100vw, 446px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/34f9d41cef976faa397e17e7bf9846be/6244b/techletter.app-screenshot-1585240252713.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Gatsby will choose production when you run `}<inlineCode parentName="p">{`gatsby build`}</inlineCode>{` and development when you run `}<inlineCode parentName="p">{`gatsby development`}</inlineCode>{`.`}</p>
    <p>{`You can even use these in the browser!`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=const%20IndexPage%20%3D%20()%20%3D%3E%20%7B%0A%20%20%2F%2F%20this%20works%20and%20is%20available%20at%20runtime%20%F0%9F%98%B1%0A%20%20console.log(process.env.GATSBY_GRAPHQL_URL)%0A%20%20%0A%20%20return%20(%0A%20%20%20%20%3CLayout%3E%0A%20%20%20%20%20%20%3CSEO%20title%3D%22Home%22%20%2F%3E%0A%20%20%20%20%20%20%3Ch1%3EHi%20people%3C%2Fh1%3E"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "470px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "66.81614349775785%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'266\\'%20viewBox=\\'0%200%20400%20266\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M28%2043c-2%203-1%20179%200%20182%203%203%20341%203%20344%200%201-3%202-179%200-182S30%2040%2028%2043\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ed4aa582023e1b8670d3ee7859e7daf2/ca0a1/techletter.app-screenshot-1585240252300.webp 223w", "/static/ed4aa582023e1b8670d3ee7859e7daf2/75680/techletter.app-screenshot-1585240252300.webp 445w", "/static/ed4aa582023e1b8670d3ee7859e7daf2/4424c/techletter.app-screenshot-1585240252300.webp 470w"],
                "sizes": "(max-width: 470px) 100vw, 470px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ed4aa582023e1b8670d3ee7859e7daf2/e92b6/techletter.app-screenshot-1585240252300.png 223w", "/static/ed4aa582023e1b8670d3ee7859e7daf2/e66bf/techletter.app-screenshot-1585240252300.png 445w", "/static/ed4aa582023e1b8670d3ee7859e7daf2/f96db/techletter.app-screenshot-1585240252300.png 470w"],
                "sizes": "(max-width: 470px) 100vw, 470px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/ed4aa582023e1b8670d3ee7859e7daf2/f96db/techletter.app-screenshot-1585240252300.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "436px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/7977c94dcd86b1996248f157bfe75057/8574c/OAwReM3.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "45.73991031390135%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'183\\'%20viewBox=\\'0%200%20400%20183\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M45%201l-1%202c-2%200-2%201-2%206v6h17V0l-1%207v7h-8V9l-1-6-3-2h-1m211%200c-2%201-1%204%202%205l3%202c0%202-3%202-4%200-2-1-2-1-2%201%201%202%205%203%207%201l2-1c1%203%205%202%206-1l2-2v2c0%203%200%203%203%203s3%200%203-3c0-5-2-5-2-1-1%203-2%203-3-1l-1-2c-1%202-1%202-3%200-2-1-3-1-5%201-1%202-1%202-4%200-3-1-4-3-2-3l3%201h1c0-2-3-3-6-2m-94%2021l40%201%2039-1c0-2-5-2-39-2-35%200-40%200-40%202M10%2037v8l8%201h9V30H10v7m39-6c-8%203-6%2014%203%2014%206%200%209-8%205-12-3-2-5-3-8-2m210%201c-2%201-6%204-6%206s6%206%209%206%209-4%209-6c0-4-8-8-12-6M16%2038v6h10V32H16v6m355%2024v2l1%203%201%202c1%201-2%201-6%201s-7%200-6-1l-2-1-2-1c-1-1%200-1%201-1l3-1c0-2-2-3-4-2-2%200-3%205-1%206%201%201-1%201-5%201s-6%200-5-1l-2-1-2-1c-1-1%200-1%201-1l3-1-4-3c-2%201-3%207-1%207%201%201-2%201-6%201-6%200-7%200-6-2%202-1%202-2%201-4-3-4-8%200-5%204%201%202%201%202-9%202-6%200-9%200-8-1l-2-1-2-2%202-2c2%200%202%200%201-1-2-3-6%202-4%205%201%202%201%202-1%202l-1%201a1680%201680%200%200097-3c0-1%200-2-2-3v-1l2-1h-5l2%203%202%202h-2c-1%200-2%200-1%201l-5%201c-4%200-6%200-5-1l-2-1-3-1%203-1c2%200%202-2%200-3h-4c-1%203-1%203%201%205%201%202%201%202-1%202s-3%200-2-1l-1-1c-3%200-2-3%200-5v-1l-2-1-2%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/7977c94dcd86b1996248f157bfe75057/ca0a1/OAwReM3.webp 223w", "/static/7977c94dcd86b1996248f157bfe75057/bfa8c/OAwReM3.webp 436w"],
              "sizes": "(max-width: 436px) 100vw, 436px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/7977c94dcd86b1996248f157bfe75057/e92b6/OAwReM3.png 223w", "/static/7977c94dcd86b1996248f157bfe75057/8574c/OAwReM3.png 436w"],
              "sizes": "(max-width: 436px) 100vw, 436px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/7977c94dcd86b1996248f157bfe75057/8574c/OAwReM3.png",
              "alt": "OAwReM3",
              "title": "OAwReM3",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`👌`}</p>
    <h4 {...{
      "id": "the-tradeoff"
    }}>{`The tradeoff`}</h4>
    <p>{`The Gatsby way breaks down when you deploy.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "471px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/011e9fe530d9a4286cda63fbe312fcc4/1f09d/FJlMtA7.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "42.152466367713004%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'169\\'%20viewBox=\\'0%200%20400%20169\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M151%203c-2%202%202%202%2036%202l36-1c-1-2-71-3-72-1M9%2019v7h16V12H9v7m37-6c-7%202-6%2013%202%2013%207%200%209-10%202-13l-2-1-2%201m190%202l-2%204c0%202%206%206%209%206%202%200%208-4%208-6%200-3-5-6-8-6l-7%202M14%2019l1%206h9V14H14v5m330%2022l1%207c1%201-2%201-5%201-5%200-7%200-6-1l-2-1-2-1%202-1%202-1c0-2-3-3-4-1l-6%201c-3%200-3%200%200%201l5%202c2%202%202%202-4%202-4%200-6%200-5-1l-2-1-2-1%202-1c3%200%202-2%200-3-4%200-5%203-2%205%201%202%201%202-6%202-4%200-6%200-5-1%202-1%201-5-2-6-3%200-4%202-2%205%201%202%201%202-8%202-6%200-9%200-8-1l-2-1c-3%200-3-3%200-4%202-1%202-1%200-1-4%200-5%206-2%206v1a890%20890%200%2000101-1c2-3%201-6-2-6-2%200-2%201-2%203l1%203c1%201%200%201-1%201s-2%200-1-1l-1-1-1-2-1-3c-1%200-2%201-1%203l-1%202v1l-3%201c-1%200-2%200-1-1%202%200%201-2-1-4-1-1-1-1%201-1v-1c-2-1-4%200-4%202l2%202v1c-1%200-2%200-1%201l-5%201c-4%200-6%200-5-1l-2-1-2-1%202-1%202-1c0-3-5-2-5%200-1%202-1%202%201%203%201%202%201%202-1%202s-3%200-2-1l-1-1-1-2%201-2v-1c-2-2-3-2-3-1M40%20116c0%202%201%205%203%204l1%201-2%201v1l-3%201c-5%200-5%200-2-5l1-4-3%204c-2%205-2%205-6%205l25%201%2026-1c-2%200-2-1-1-1%202-1%202-7%201-8h-4l2%201%201%201-1%201v1c2%202%201%203-1%203s-2%200-1%201-1%201-5%201c-6%200-7%200-6-1%202-1%202-7%201-8h-4l2%201v3c2%200%201%203-1%203s-2%200-1%201-1%201-5%201c-6%200-7%200-6-1%203-1%202-4%200-5l-1-2%202-1-2-1c-3%201-4%205-1%205l2%202-2%201c-2%200-2%200-1%201s1%201-2%201-3%200-2-2l2-3c0-4-4-7-6-3\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/011e9fe530d9a4286cda63fbe312fcc4/ca0a1/FJlMtA7.webp 223w", "/static/011e9fe530d9a4286cda63fbe312fcc4/75680/FJlMtA7.webp 445w", "/static/011e9fe530d9a4286cda63fbe312fcc4/7e43b/FJlMtA7.webp 471w"],
              "sizes": "(max-width: 471px) 100vw, 471px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/011e9fe530d9a4286cda63fbe312fcc4/e92b6/FJlMtA7.png 223w", "/static/011e9fe530d9a4286cda63fbe312fcc4/e66bf/FJlMtA7.png 445w", "/static/011e9fe530d9a4286cda63fbe312fcc4/1f09d/FJlMtA7.png 471w"],
              "sizes": "(max-width: 471px) 100vw, 471px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/011e9fe530d9a4286cda63fbe312fcc4/1f09d/FJlMtA7.png",
              "alt": "FJlMtA7",
              "title": "FJlMtA7",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Both Zeit and Netlify helpfully strip your `}<inlineCode parentName="p">{`.env`}</inlineCode>{` files during deploy. Wouldn't want to store secrets in plaintext on their servers.`}</p>
    <p>{`This is great from a security perspective.`}</p>
    <p>{`And it breaks Gatsby support for .env files. They aren't available during build. 🤦‍♂️`}</p>
    <h3 {...{
      "id": "2-the-zeit-way"
    }}>{`2. The Zeit way`}</h3>
    <p><a parentName="p" {...{
        "href": "https://zeit.co/docs/v2/build-step#using-environment-variables-and-secrets"
      }}>{`The Zeit way`}</a>{` is more secure. You store secrets and configs in their secure storage. Encrypted, easy to rotate, not part of your code.`}</p>
    <p>{`Now you gotta jump a couple more hoops.`}</p>
    <p>{`First you add your secret to Zeit`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=shell&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=now%20secrets%20add%20graphql_url%20https%3A%2F%2F...%2Fdev%2Fgraphql"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "510px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "36.77130044843049%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'147\\'%20viewBox=\\'0%200%20400%20147\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M26%2039c-2%202-2%2068%200%2070s346%202%20348%200%202-68%200-70-346-2-348%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a64dd80823b60004be4674349965d981/ca0a1/techletter.app-screenshot-1585240252577.webp 223w", "/static/a64dd80823b60004be4674349965d981/75680/techletter.app-screenshot-1585240252577.webp 445w", "/static/a64dd80823b60004be4674349965d981/b7235/techletter.app-screenshot-1585240252577.webp 510w"],
                "sizes": "(max-width: 510px) 100vw, 510px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a64dd80823b60004be4674349965d981/e92b6/techletter.app-screenshot-1585240252577.png 223w", "/static/a64dd80823b60004be4674349965d981/e66bf/techletter.app-screenshot-1585240252577.png 445w", "/static/a64dd80823b60004be4674349965d981/0abdd/techletter.app-screenshot-1585240252577.png 510w"],
                "sizes": "(max-width: 510px) 100vw, 510px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/a64dd80823b60004be4674349965d981/0abdd/techletter.app-screenshot-1585240252577.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Then you create a `}<inlineCode parentName="p">{`now.json`}</inlineCode>{` file`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=json&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%7B%0A%20%20%20%20%22build%22%3A%20%7B%0A%20%20%20%20%20%20%20%20%22env%22%3A%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20%22GRAPHQL_URL%22%3A%20%22%40graphql_url%22%2C%0A%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%7D%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "438px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "67.2645739910314%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'269\\'%20viewBox=\\'0%200%20400%20269\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M30%2046c-2%203-1%20176%200%20179%203%203%20337%203%20340%200%201-3%202-176%200-179S32%2043%2030%2046\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a134c7c370717df10d343effdb23f1fd/ca0a1/techletter.app-screenshot-1585240252554.webp 223w", "/static/a134c7c370717df10d343effdb23f1fd/4a74f/techletter.app-screenshot-1585240252554.webp 438w"],
                "sizes": "(max-width: 438px) 100vw, 438px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a134c7c370717df10d343effdb23f1fd/e92b6/techletter.app-screenshot-1585240252554.png 223w", "/static/a134c7c370717df10d343effdb23f1fd/50e4b/techletter.app-screenshot-1585240252554.png 438w"],
                "sizes": "(max-width: 438px) 100vw, 438px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/a134c7c370717df10d343effdb23f1fd/50e4b/techletter.app-screenshot-1585240252554.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`And `}<em parentName="p">{`then`}</em>{`, you use it in `}<inlineCode parentName="p">{`gatsby-config`}</inlineCode></p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20gatsby-config.js%0A%0A%2F%2F%20your%20config%0A%2F%2F%20..%0A%20%20plugins%3A%20%5B%0A%20%20%20%20%7B%0A%20%20%20%20%20%20resolve%3A%20%22gatsby-source-graphql%22%2C%0A%20%20%20%20%20%20options%3A%20%7B%0A%20%20%20%20%20%20%20%20typeName%3A%20%22MDLAPI%22%2C%0A%20%20%20%20%20%20%20%20fieldName%3A%20%22mdlapi%22%2C%0A%20%20%20%20%20%20%20%20url%3A%20process.env.GRAPHQL_URL%2C%0A%20%20%20%20%20%20%7D%2C%0A%20%20%20%20%7D%2C"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "414px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "97.30941704035874%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'389\\'%20viewBox=\\'0%200%20400%20389\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M33%2048c-3%203-3%20292%200%20294%202%203%20332%203%20334%200%203-3%203-292%200-294-3-3-332-3-334%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/0ead187a318e37177deda4445c0b163c/ca0a1/techletter.app-screenshot-1585240252651.webp 223w", "/static/0ead187a318e37177deda4445c0b163c/3ca80/techletter.app-screenshot-1585240252651.webp 414w"],
                "sizes": "(max-width: 414px) 100vw, 414px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/0ead187a318e37177deda4445c0b163c/e92b6/techletter.app-screenshot-1585240252651.png 223w", "/static/0ead187a318e37177deda4445c0b163c/b910a/techletter.app-screenshot-1585240252651.png 414w"],
                "sizes": "(max-width: 414px) 100vw, 414px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/0ead187a318e37177deda4445c0b163c/b910a/techletter.app-screenshot-1585240252651.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`When you deploy to Zeit, the build process takes your `}<inlineCode parentName="p">{`now.json`}</inlineCode>{`, replaces `}<inlineCode parentName="p">{`@variable`}</inlineCode>{` with values from storage, loads the configs into `}<inlineCode parentName="p">{`process.env`}</inlineCode>{`, and Gatsby can use them while building.`}</p>
    <p>{`Sounds complicated ... 🤨`}</p>
    <p>{`But it works. Sort of`}</p>
    <p><a parentName="p" {...{
        "href": "https://docs.netlify.com/configure-builds/get-started/"
      }}>{`Netlify has a similar approach`}</a>{`, by the way.`}</p>
    <h4 {...{
      "id": "the-tradeoff-1"
    }}>{`The tradeoff`}</h4>
    <p>{`Notice there's no prod vs. dev. You get `}<em parentName="p">{`a`}</em>{` config and that's it. Zeit says they'll have native support for environments soon.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/zeit_support/status/1242094643002642432"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "60.53811659192825%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'242\\'%20viewBox=\\'0%200%20400%20242\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M23%2017c-13%207-8%2027%207%2027s20-20%206-27c-5-3-7-3-13%200m85%208l1%205%201-1%203-1%202-2%201%201c1%203%203%204%203%202l1-1%203-1c1-2%202-2%204%200%204%202%208-2%205-6h-6c-2%202-2%202-2%200-1-1-6-2-8%200h-1l-4-1c-3%200-3%200-3%205\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c06bc41506e0880f564825ebd0bb194d/ca0a1/techletter.app-screenshot-1585240253445.webp 223w", "/static/c06bc41506e0880f564825ebd0bb194d/75680/techletter.app-screenshot-1585240253445.webp 445w", "/static/c06bc41506e0880f564825ebd0bb194d/0ba47/techletter.app-screenshot-1585240253445.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c06bc41506e0880f564825ebd0bb194d/e92b6/techletter.app-screenshot-1585240253445.png 223w", "/static/c06bc41506e0880f564825ebd0bb194d/e66bf/techletter.app-screenshot-1585240253445.png 445w", "/static/c06bc41506e0880f564825ebd0bb194d/6af66/techletter.app-screenshot-1585240253445.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/c06bc41506e0880f564825ebd0bb194d/6af66/techletter.app-screenshot-1585240253445.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`The other tradeoff is that these configs aren't available at runtime. You get them when compiling and can't use them in the browser.`}</p>
    <p>{`And you can't `}<inlineCode parentName="p">{`import 'now.json'`}</inlineCode>{` either. Zeit deletes that file ☹️`}</p>
    <h3 {...{
      "id": "3-the-way-that-actually-works"
    }}>{`3. The way that actually works`}</h3>
    <p>{`In the end, here's what works best:`}</p>
    <ol>
      <li parentName="ol">{`Put your configs in JSON files`}</li>
      <li parentName="ol">{`Import in gatsby-config.js`}</li>
      <li parentName="ol">{`Add to `}<inlineCode parentName="li">{`siteMetadata`}</inlineCode></li>
      <li parentName="ol">{`Access via static queries`}</li>
    </ol>
    <p>{`Kinda bonkers but it works.`}</p>
    <p>{`You start with 2 JSON files similar to the original `}<inlineCode parentName="p">{`.env`}</inlineCode>{` approach.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=json&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20config.development.json%0A%7B%0A%09%22GRAPHQL_URL%22%3A%20%22https%3A%2F%2F...%2Fdev%2Fgraphql%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "446px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "54.26008968609865%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'216\\'%20viewBox=\\'0%200%20400%20216\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M30%2044l-1%2065c0%2061%200%2063%202%2064h338c2-1%202-3%202-64l-1-65c-2-2-338-2-340%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/51342f0321d34b7780b02b79db78384c/ca0a1/techletter.app-screenshot-1585240252625.webp 223w", "/static/51342f0321d34b7780b02b79db78384c/75680/techletter.app-screenshot-1585240252625.webp 445w", "/static/51342f0321d34b7780b02b79db78384c/5021b/techletter.app-screenshot-1585240252625.webp 446w"],
                "sizes": "(max-width: 446px) 100vw, 446px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/51342f0321d34b7780b02b79db78384c/e92b6/techletter.app-screenshot-1585240252625.png 223w", "/static/51342f0321d34b7780b02b79db78384c/e66bf/techletter.app-screenshot-1585240252625.png 445w", "/static/51342f0321d34b7780b02b79db78384c/6244b/techletter.app-screenshot-1585240252625.png 446w"],
                "sizes": "(max-width: 446px) 100vw, 446px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/51342f0321d34b7780b02b79db78384c/6244b/techletter.app-screenshot-1585240252625.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=json&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20config.development.json%0A%7B%0A%09%22GRAPHQL_URL%22%3A%20%22https%3A%2F%2F...%2Fprod%2Fgraphql%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "454px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "52.91479820627802%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'212\\'%20viewBox=\\'0%200%20400%20212\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M30%2044c-3%202-3%20123%200%20125%202%203%20338%203%20340%200%203-3%203-123%200-125-3-3-338-3-340%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/b8c69351972ef4e7d91afa2438f0f4ea/ca0a1/techletter.app-screenshot-1585240252559.webp 223w", "/static/b8c69351972ef4e7d91afa2438f0f4ea/75680/techletter.app-screenshot-1585240252559.webp 445w", "/static/b8c69351972ef4e7d91afa2438f0f4ea/44d9f/techletter.app-screenshot-1585240252559.webp 454w"],
                "sizes": "(max-width: 454px) 100vw, 454px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/b8c69351972ef4e7d91afa2438f0f4ea/e92b6/techletter.app-screenshot-1585240252559.png 223w", "/static/b8c69351972ef4e7d91afa2438f0f4ea/e66bf/techletter.app-screenshot-1585240252559.png 445w", "/static/b8c69351972ef4e7d91afa2438f0f4ea/b3c1d/techletter.app-screenshot-1585240252559.png 454w"],
                "sizes": "(max-width: 454px) 100vw, 454px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/b8c69351972ef4e7d91afa2438f0f4ea/b3c1d/techletter.app-screenshot-1585240252559.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Import in `}<inlineCode parentName="p">{`gatsby-config.js`}</inlineCode></p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20gatsby-config.js%0Aconst%20config%20%3D%20require(%60.%2Fconfig.%24%7Bprocess.env.NODE_ENV%7D.json%60)%0A%0Amodule.exports%20%3D%20%7B%0A%20%20siteMetadata%3A%20%7B%0A%20%20%20%20%2F%2F%20...%0A%20%20%20%20%2F%2F%20this%20makes%20configs%20available%20in%20static%20queries%0A%20%20%20%20myConfig%3A%20%7B%0A%20%20%20%20%20%20graphql_url%3A%20config.GRAPHQL_URL%2C%0A%20%20%20%20%7D%2C%0A%20%20%7D%2C%0A%20%20plugins%3A%20%5B%0A%20%20%20%20%7B%0A%20%20%20%20%20%20resolve%3A%20%22gatsby-source-graphql%22%2C%0A%20%20%20%20%20%20options%3A%20%7B%0A%20%20%20%20%20%20%20%20typeName%3A%20%22MDLAPI%22%2C%0A%20%20%20%20%20%20%20%20fieldName%3A%20%22mdlapi%22%2C%0A%20%20%20%20%20%20%20%20url%3A%20config.GRAPHQL_URL%2C%0A%20%20%20%20%20%20%7D%2C%0A%20%20%20%20%7D%2C"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "606px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "87.44394618834082%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'349\\'%20viewBox=\\'0%200%20400%20349\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M22%2034a8508%208508%200%20001%20283c2%202%20352%202%20354%200%202-1%202-12%202-142l-1-141c-1-3-355-3-356%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/11bead4bdda709dd764d73ca63638458/ca0a1/techletter.app-screenshot-1585240252659.webp 223w", "/static/11bead4bdda709dd764d73ca63638458/75680/techletter.app-screenshot-1585240252659.webp 445w", "/static/11bead4bdda709dd764d73ca63638458/18e7e/techletter.app-screenshot-1585240252659.webp 606w"],
                "sizes": "(max-width: 606px) 100vw, 606px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/11bead4bdda709dd764d73ca63638458/e92b6/techletter.app-screenshot-1585240252659.png 223w", "/static/11bead4bdda709dd764d73ca63638458/e66bf/techletter.app-screenshot-1585240252659.png 445w", "/static/11bead4bdda709dd764d73ca63638458/4d4a2/techletter.app-screenshot-1585240252659.png 606w"],
                "sizes": "(max-width: 606px) 100vw, 606px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/11bead4bdda709dd764d73ca63638458/4d4a2/techletter.app-screenshot-1585240252659.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Use the configs directly in your build-time code via `}<inlineCode parentName="p">{`config.X`}</inlineCode>{`. Works just fine.`}</p>
    <p>{`You can import JSON files in the browser, sure, but you won't know which environment. Put them in `}<inlineCode parentName="p">{`siteMetadata.myConfig`}</inlineCode>{` instead, so you can get configs with static queries anywhere in your app.`}</p>
    <p>{`Like this`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=const%20IndexPage%20%3D%20(%7B%20%7D)%20%3D%3E%20%7B%0A%0A%20%20const%20%7B%20site%20%7D%20%3D%20useStaticQuery(%0A%20%20%20%20graphql%60%0A%20%20%20%20%20%20query%20%7B%0A%20%20%20%20%20%20%20%20site%20%7B%0A%20%20%20%20%20%20%20%20%20%20siteMetadata%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20myConfig%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20graphql_url%0A%20%20%20%20%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%20%20%7D%0A%20%20%20%20%60%0A%20%20)%0A%20%20%0A%20%20console.log(site.siteMetadata.myConfig.graphql_url)"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "526px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "90.13452914798206%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'361\\'%20viewBox=\\'0%200%20400%20361\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M26%2038c-2%202-2%2013-2%20143v142l2%201c4%203%20344%203%20348%200l2-1V181c0-136%200-142-2-143-3-3-346-3-348%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/1106fcc2eb79c9b45044d49c35d489da/ca0a1/techletter.app-screenshot-1585240252432.webp 223w", "/static/1106fcc2eb79c9b45044d49c35d489da/75680/techletter.app-screenshot-1585240252432.webp 445w", "/static/1106fcc2eb79c9b45044d49c35d489da/9752a/techletter.app-screenshot-1585240252432.webp 526w"],
                "sizes": "(max-width: 526px) 100vw, 526px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/1106fcc2eb79c9b45044d49c35d489da/e92b6/techletter.app-screenshot-1585240252432.png 223w", "/static/1106fcc2eb79c9b45044d49c35d489da/e66bf/techletter.app-screenshot-1585240252432.png 445w", "/static/1106fcc2eb79c9b45044d49c35d489da/2d7ab/techletter.app-screenshot-1585240252432.png 526w"],
                "sizes": "(max-width: 526px) 100vw, 526px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/1106fcc2eb79c9b45044d49c35d489da/2d7ab/techletter.app-screenshot-1585240252432.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`And you get ...`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "626px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/39430e9fd969e9fc6f8e46b0453e53c0/af590/ujVZMF7.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "37.668161434977584%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'150\\'%20viewBox=\\'0%200%20400%20150\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M113%201l28%201%2027-1-27-1-28%201M6%208v6l1%204h12V7h-6L6%208m5%2016c-2%201-3%205-2%208%203%203%2018%203%2021%200%201-3%200-7-3-8H11m208%2041c0%202%200%203-1%202l-2-1-1-1%201-1%202-1c-2-2-4%200-4%203v2a2293%202293%200%2000129-2v-1c2%200%203-2%201-3s-4%203-3%205v1c-1%200-2-1-2-4-1-4-2-4-2%200l-1%203c0%201-4-3-4-5l-1-1-1%204v3c-1%200-2-1-2-3l-1-2-1%202c0%202-1%203-2%203v-3c0-5-1-5-4-2-1%203-1%203-2%201-2-4-4-4-4%200%200%203%200%204-2%204s-2%200%200-3l1-4-3%203-3%204c-2%200-2%200%200-3l1-4-3%203c-1%204-4%205-4%203l-1-1v1l-1%201-2-1v-3c-1-3-4-2-4%202l-1%202-1-3-1-2-1%202c0%205-3%203-3-1-1-4-2-4-2%200%200%203-2%205-3%204v-3c0-3-1-4-3-2l1%202c1%201%201%202-1%202-2%201-2%201-2-1%200-5-4-5-4%200%200%201%200%202-1%201h-2l-1-1%202-1v-3c-2-1-5%203-3%205%201%201%201%201-1%201l-1-3-1-3-1%203c0%204-2%204-4%201%200-2-1-3-2-3l-1%201v3h-1l-1-1h-1v-1c2%200%203-2%201-3s-4%203-3%205c1%201-4%202-7%200-2%200-2-2%200-2v-2h-5c-1-2-4%200-4%202l-1%203-1-3-1-2-1%202c0%202-1%203-3%203s-3-3-1-4l1-1c-1-2-3%200-3%203l-1%202-1-2-2-4c-2-1-2-1-2%203m159%200c0%202%200%203-1%201%200-2-2-4-3-4l-1%201v2l-1-1c-1-3-4-2-5%201%200%203-2%203-2%200l-1-3-1%201c1%202%200%205-2%205l-1-3-1-2-2%202-1%203v-2c0-2-2-4-4-3l-1%203v2c-1%201%200%201%203%201h25c12%200%2021%200%2020-1l-1-3-1-2-2-1c-1-1-1%200-1%202l-1%204v-3l-1-4-4%205v2l-1-1h-1l-1-1%201-1%201-2c-2-2-4%200-4%203v2c-1%200-2-3-1-5h-1c-2%201-2%201-2-1-1-1-1%200-1%203M20%2096l-1%204h85l-1-4c0-5%200-5-2-3-2%201-2%203-2%204v2l-1-3c0-4%200-4-2-4s-2%200-2%204c1%203%201%203-3%203s-4%200-4-3c0-4-1-5-3-2-1%202-1%202%201%204%201%201%201%201-1%201s-3%200-3-3l-1-2-1%202c0%202-1%203-2%203-2%200-2%200-1-3l1-3-2%201c0%202%200%202-1%201s-1-1-1%201c1%202%201%203-1%203l-1-2c1-1%200-2-1-3-2-3-3-2-3%202%201%203%200%204-2%202-1-2-2-4%200-3l1-1-2-1-1%203c0%203-1%203-3%203s-2%200-1-3l1-4-2%203c-1%203-3%205-5%204l1-4%201-3-2%204c-2%203-3%204-4%202h-4l-1-2v-2l-1-1c-1%200-3%202-1%203v2c-2%202-3%201-3-2l-1-3c-2%200-2%201-2%203l-1%203-2-5c1-1-1-2-2-2v4c1%203%200%204-3%201v-4c-2-1-3%200-2%203%201%202%201%203-1%203l-1-2-2-4c-2-2-2-2-2%203m155-4v3l-3%204-1-3-1-3c-2%200-2%201-2%203v4h82c45%200%2081%200%2080-1-2%200-2%200%200-4v-3l-2%204c-2%204-4%204-4%200v-1c0%201-1%201-2-1s-2%200%200%203v2l-2-1-2-1v-1c2%200%202-2%200-2l-1%202c0%202-1%203-2%203v-3c0-4-1-5-3-2-1%201-2%202-1%203%200%202%200%202-2%202s-2%200-1-2c1-4%201-5-1-2s-2%203-2%201c-1-4-5-4-5%200l-1%203-1-3-1-2-1%202c0%202-1%203-2%203v-1l-1-1c-2%200-2-1-1-3v-1l-1%203c0%202-1%203-2%203l-2-1-1-2-1%202-1%201-1-1-1-3v-2c-2%200-4%202-2%203v2c-2%202-3%201-2-2%200-2%200-3-1-2l-1%201-2-1c-1-1-1%200-1%202v3l-1-3c0-2%200-3-2-3v1c1%201%201%201-1%201l-1%203v1l-1-3c-1-4-4-4-4%200l-1%203v-2c0-3-2-5-4-3v5c-2%200-2-1-2-4l-1-2-2%201-1%205-1-3c0-2%200-3-2-3l-1%201v1h-2c-1-3-4-2-4%200s1%203%203%203c3%201%203%201%200%201-4%200-4%200-4-3l-2-3c-2%200-2%200-2%203%200%202-1%203-2%203l-1-2h-1v1l-1%201c-2%200-3-2-3-5l-2-2v2c2%203%200%205-5%205-3%200-4-2-4-5l-1-2-1%203c1%203%201%204-1%204l-1-1-1-3v-2c-2%200-3%201-2%203v2l-1%201-1-3c0-2-4-4-4-2l1%201v1l-2%202-2-1v-1c2%200%202-2%200-3l-1%201-3%201c-4%200-6%201-2%201l4%202c1%201%201%201-3%201s-5%200-4-1l-1-3v-2c-2%200-4%202-2%203l-1%202c-1%201-1%200-1-2-1-3-1-3-2-1v3l-1-3c-1-2-1-2-1%201%201%202%200%203-1%203l-2-2h-1v1h-3l-1-4-1-2m-27%201v3c1%203%201%203-1%203-1%200-2-1-1-2%200-3-2-4-2-1-1%201-1%201-1-1%200-1%200-2-1-1l-1%203c1%202%200%203-2%201-1-2-2-4%200-3l1-1-2-1-1%203-1%203-1-1-2-1v-1c2%200%203-2%201-3l-3%202c-2%202-2%202-2%200%201-1%200-2-2-2l-1%201c1%202-1%205-3%203v-1c1%200%202-1%201-2-1-2-4%200-4%203%201%201%200%202-1%202l-1-1-1-2-1%202-1%201-1-1-2-1v-1l2-1c0-2-2-2-3-1h-3c-1-2-4-1-4%202l2%202v2l3-1%201-1v1c-1%201%2011%201%2028%201h29v-3l-2-4c-2%200-2%200-2%203s-1%203-4%203l-3-1-2-1v-1c2%200%202-2%200-2l-1%202c0%203-2%203-3%201v-4h-2M20%20111l-1%204h85l-1-4c0-4%200-4-2-3s-2%202-2%204v2l-1-3c0-4%200-4-2-4s-2%201-2%204c0%202%200%203-1%202%200-3-3-6-4-6l-1%204v3l-1-3c0-4-1-5-3-2-1%202-1%202%201%204%201%201%201%201-1%201s-3%200-3-3l-1-2-1%202c0%202-1%203-2%203-2%200-2%200-1-2s0-4-1-2h-1l-1-1c-1%201-2%200-3-1-2-2-3-1-3%203v3l-1-1h-1l-1-1%201-2%201-2c-1-1-4%202-4%204%201%202%200%202-2%202s-2%200%200-3l1-4-3%203c-2%206-6%206-4%201l1-4-2%204c-2%203-3%204-4%202h-2c0%202-3%201-2%200l-1-2v-2c-1-1-3%200-3%201l-1%204v-2l-1-3c-2-2-4%201-3%203l-1%202-1-3-1-4c-2-1-3%202-2%205%201%202-1%203-3%200v-4c-2-2-3%200-2%203%201%202%201%203-1%203l-1-2-2-4c-2-1-2-1-2%203m128-3v3l-1%203-1-2c0-4-2-4-2-1l-1%203v-3l-1-2-1%203v2l-1-1h-1l-1-1%201-2%201-1c-2-2-4%200-4%203v2l-1-4c0-1-2-2-3-1h-4l-2%202c0%202-2%203-2%201v-2c-2-3-4-1-4%202%201%202-1%203-2%201h-2c-1%202-3%200-2-3%200-1-2-2-3-1h-3c-2-1-4%201-3%204%200%203%203%204%203%202h31a289%20289%200%200031-1l83%201h83v-3c0-2-1-3-2-3l-1%202c0%202-1%203-3%203s-2%200-1-3c2-3%202-4%201-4l-2%204c-2%204-4%204-3%201v-3l-1%201h-1c-2-1-2-1-1%202v2l-2-1v-3c-1-3-4-2-3%201l-1%203-1-3-1-4-4%205c1%202%200%202-1%202-2%200-2%200%200-4v-3l-2%203c-1%203-1%203-2%201s-5-4-5-2h-2c-2-2-5%201-3%204h-2c-2-1-3-3%200-3v-1c-2-2-5%202-3%204%201%201%201%201-1%201l-2-1h-2c0%202-3%201-2%200l-1-2v-2c-1-1-3%200-3%201l-1%204v-2c0-2%200-3-3-2l-4-1c-1-2-3%200-3%203v2l-1-2-1-3c-1-2-3%200-3%203l-1%202v-2c0-3-2-5-3-3h-6l-1%205-1-1c1-3-1-6-3-4h-2l-2-1-2%201h-1c-2-2-4-1-4%200v4l-1%201-2-1h-2c-1%202-3%200-3-4%200-2-1-3-2-1v1c1%200%201%203-1%204l-4%201c-3%200-3-1-3-3l-1-3-1%203c0%202-1%203-2%203l-1-1-1-2v-2c-1-1-3%201-2%202v2c-1%201-2%200-2-2%200-3-3-4-4-1v2c0%202-4%201-4%200l1-1c1%201%202-1%201-2h-2l-4%201-3%201%202%201c2-1%203%200%203%201%201%201%200%201-3%201s-4%200-3-1l-1-2v-2c-1-1-3%200-3%201v3c-1%201-1%201-1-1%200-3-2-4-2-1h-1c-1-2-1-2-1%200%200%203-2%204-3%202h-2c-1%202-3-1-3-4%200-1%200-2-1-1v2l-1%203c-2%201-3%201-3-2%201-4-2-3-3%201-1%202-1%202-1%200s-1-3-2-3c-2-1-2-1-2%201v1l-1%202c1%201%200%201-2%201l-4-1c-1-2%200-2%202-1l3-1c1-1%200-1-2-1l-4-1c-1-2-3%200-3%203%201%202%200%203-2%200v-4h-2m205%202l-1%204-1-3-1-2-2%202-1%203v-2l-3-4-1%202v1l-1%202c1%201%200%201-1%201-2%200-3-3-1-4l1-1c-1-2-3%200-3%203-1%203-1%203%205%203h22c3%200%204-1%202-2l-1-4-1-2v4c1%202%200%203-1%203l-1-2c0-3-2-5-4-3l-1%203v2l-1-2-2-4c-2-1-2-1-2%202M20%20126l-1%204h85l-1-4c0-5%200-5-2-3-2%201-2%203-2%204v2l-1-3c0-4%200-4-2-4s-2%200-2%204c1%203%201%203-3%203s-4%200-4-3c0-4-1-5-3-2-1%202-1%202%201%204%201%201%201%201-1%201s-3%200-3-3l-1-2-1%202c0%202-1%203-2%203-2%200-2%200-1-3l1-3-2%201c0%202%200%202-1%201s-1-1-1%201c1%202%201%203-1%203l-1-2c1-1%200-2-1-3-2-3-3-2-3%202%201%203%200%204-2%201v-2c2-1%201-2-2-2l-1%204c1%202%201%202-1%202-3%200-3%200-1-3v-4l-2%204-3%203c-2%200-2%200%200-4v-3l-2%204c-2%203-4%204-4%202l-1-1v1l-2%201c-1%200-2%200-1-1l-1-2v-2l-1-1c-1%200-3%202-1%203l1%201-1%201h-1l-1%201-1-3-1-3c-2%200-2%201-2%203l-1%203-2-5c1-1-1-2-2-2v7c-3%200-4-3-3-4v-2c-2-1-3%200-2%203%201%202%201%203-1%203l-1-2-2-4c-2-2-2-2-2%203m155-4v3l-3%204-1-3-1-3c-2%200-2%201-2%203l-1%203v-2l-1-4c-3%200-3%200-3%203s-1%203-4%203l-3-1-2-1v-1c2%200%202-2%200-2l-1%202c0%203-2%203-3%201v-4c-3-1-3%200-2%203s1%203-1%203c-1%200-2-1-1-2%200-3-2-4-2-1-1%201-1%201-1-1%200-1%200-2-1-1l-1%203c1%202%200%203-2%201-1-2-2-4%200-3l1-1-2-1-1%203-1%203-1-1-2-1v-1c2%200%203-2%201-3l-3%202c-1%202-2%202-2%201l-2-2h-1c1%202-1%205-3%203v-1c1%200%202-1%201-2-1-2-4%200-4%203%201%201%200%202-1%202l-2-1v-1h-1l-1%202-1-1-2-1v-1l2-1c0-2-2-2-3-1h-2c-1-2-4-1-5%201%200%201%200%202%202%203v2c0%201%201%201%202-1l2-1v1a5984%205984%200%2000226-3c0-2%200-3-2-3-2%201-3%204-1%205%201%201%200%201-2%201-3%200-4%200-1-4v-3l-2%204c-2%204-4%204-4%200v-1c0%201-1%201-2-1s-2%200%200%203v2l-2-1-2-1v-1c2%200%202-2%200-2l-1%202c0%202-1%203-2%203v-4c0-3%200-3-2-2s-3%202-2%204c0%202%200%202-2%202s-2%200-1-2c1-4%201-5-1-2s-2%203-2%201c-1-4-5-4-5%200l-1%203-1-3-1-2-1%202c0%202-1%203-2%203v-1l-1-1c-2%200-2-1-1-3v-1l-1%203c0%202-1%203-2%203l-2-1-1-2-1%202-1%201-1-1-1-3v-2c-2%200-4%202-2%203v2c-2%202-3%201-2-2%200-2%200-3-1-2l-1%201-2-1c-1-1-1%200-1%202v3l-1-3-1-3c-2%200-2%201-2%205%200%202-2%201-2-2-1-4-4-4-4%200l-1%203v-2c0-3-2-5-4-3v5c-2%200-2-1-2-4l-1-2-2%201-1%205-1-3c0-2%200-3-2-3l-1%201v1h-2c-1-3-4-2-4%200s1%203%203%203c3%201%203%201-1%201-3%200-4%200-3-2l-1-4c-3%200-3%200-3%203%200%202-1%203-2%203l-1-2h-1v1l-1%201c-2%200-3-2-3-5l-1-2c-2%200-2%202-1%202%203%201-1%204-4%205-4%200-6-2-5-5l-1-2-1%203c1%203%201%204-1%204l-1-1-1-3v-2c-2%200-3%201-2%203v2l-1%201-1-3c0-2-4-4-4-2l1%201v1l-2%202-2-1v-1l2-1c0-2-2-2-3-1l-4%201c-3%200-3%200-1%201%205%201%206%203%201%203-4%200-5%200-4-1l-1-3v-2c-2%200-4%202-2%203l-1%202c-1%201-1%200-1-2-1-3-1-3-2-1v3l-1-3c-1-2-1-2-1%201%201%202%200%203-1%203l-2-2h-1v1h-3l-1-4c0-3-1-3-1-2M20%20141l-1%204h85l-1-4-1-3-2%201v3l-2%202v-3c0-4%200-4-2-4s-2%200-2%204l-1%203v-2c0-1-3-5-5-5v7l-1-3-1-4-1%203h-1c-2%200-1%201%201%203%201%201%201%201-1%201s-3%200-3-3l-1-2-1%202c0%202-1%203-2%203-2%200-2%200-1-2v-2h-2l-1-1c-1%201-3%200-3-1-3-2-3-1-3%203%201%203%201%203-2%202-2-1-2-1-1-3l1-1c-1-1-3%202-3%203%201%202%200%202-2%202s-2%200%200-3l1-4-3%203-3%204c-2%200-2%200%200-4v-3l-2%204c-1%203-3%204-4%202h-2c0%202-3%201-2%200l-1-2v-2c-2-2-4%201-2%202%201%201%201%202-1%202-2%201-2%201-1-1l-1-3c-2-1-3%200-3%203l-1%202-2-3c0-2-1-3-2-3v4c1%202-1%203-3%200v-4c-2-1-3%201-2%204%201%201%201%202-1%202l-1-2-1-3-2-1c-1-1-1%200-1%203m128-3v3l-1%203c-1%200-2-1-1-2l-1-3-1%202-1%203v-3l-1-2-1%203c1%202%201%202-2%201-2-1-2-1-1-3l1-1c-1-1-3%202-3%204%201%201%201%201-1%201l-2-1-1-1%201-1c1%201%202-1%201-2-2-2-4%202-3%204v1l-1-3-2-2-2%202c1%201-1%203-3%202-2%200-1-2%201-2v-1c-2-3-4-1-4%202%201%202-1%203-2%201h-2c-1%201-5%200-5-1l1-1c2%201%202-2%201-2h-3c0%202%200%202-2%200h-3c-1%202-1%207%201%207l1-1a536%20536%200%200162%200%203361%203361%200%2001161-1c-2%200-2%200-1-4l1-3-2%204-3%203v-5l-1%201h-1c-2-1-2-1-1%202%201%202-1%203-4%201v-2l2-1c-1-3-4-2-3%201l-1%203-1-4c0-3%200-3-2-2l-2%204-2%202c-2%200-2%200-1-2%201-4%201-5-1-2l-2%202c0-2-3-4-4-3l-1%203-1%202v-2l-1-3c-2-1-4%201-3%204%201%201-1%202-3%200-1-2-1-3%201-3l1-1c-2-2-4%200-4%203%201%202-2%203-3%201h-2c0%202-3%201-2%200l-1-2v-2c-1-1-3%201-2%202s1%202-1%202c-2%201-2%201-1-2%200-2%200-2-1-1l-1%201-2-1c-1-1-1-1-1%201v3l-1-2c0-3-1-4-3-3v2l-1%202v1l-1-2-1-3c-1-2-3%200-3%203l-1%202v-2l-1-3c-2-1-4%202-3%204v1c-2%200-3-2-2-3s1-2-1-2c-2-1-2-1-2%201%201%201%200%204-1%204l-1-2c0-3-1-4-3-3h-4l-2%202h-1l-1-2h-2l-1%201v3l-1%201-2-1-1-1v1l-2%201-2-4c0-3-1-4-2-2v1l1%203c-1%203-9%203-10%200a420%20420%200%2000-2-1c1%202%200%203-1%203l-1-1-1-2v-2h-2v2c2%202%202%202%200%202-2%201-2%201-2-2%200-2-3-4-4-1v2c0%202-4%201-4%200l1-1h2c0-2-2-3-3-2l-4%201c-2%200-3%200-2%201l2%201%203%201-4%201c-3%200-4%200-3-1l-1-2v-2c-1-1-3%201-2%202v2c-2%201-2%200-2-2%200-3-2-3-2%200%200%202%200%202-1%200l-1-2v2c0%203-2%204-3%202h-2c-1%202-3%200-3-2l-1-2-1%202-1%203c-1%200-2%200-1-1v-3c-1-3-4-1-4%202l-1%202v-2c0-1-2-4-3-3v1l-1%202v1h-8v-2c2-1%200-3-2-2l-1%203c1%202%200%203-2%200v-4h-2\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/39430e9fd969e9fc6f8e46b0453e53c0/ca0a1/ujVZMF7.webp 223w", "/static/39430e9fd969e9fc6f8e46b0453e53c0/75680/ujVZMF7.webp 445w", "/static/39430e9fd969e9fc6f8e46b0453e53c0/63b03/ujVZMF7.webp 626w"],
              "sizes": "(max-width: 626px) 100vw, 626px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/39430e9fd969e9fc6f8e46b0453e53c0/e92b6/ujVZMF7.png 223w", "/static/39430e9fd969e9fc6f8e46b0453e53c0/e66bf/ujVZMF7.png 445w", "/static/39430e9fd969e9fc6f8e46b0453e53c0/af590/ujVZMF7.png 626w"],
              "sizes": "(max-width: 626px) 100vw, 626px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/39430e9fd969e9fc6f8e46b0453e53c0/af590/ujVZMF7.png",
              "alt": "ujVZMF7",
              "title": "ujVZMF7",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p><img parentName="p" {...{
        "src": "/3be462978f74424a3a1e04a80d644e0f/media-hZj44bR9FVI3K-giphy.gif",
        "alt": "yay giphy"
      }}></img></p>
    <h4 {...{
      "id": "the-tradeoff-2"
    }}>{`The tradeoff`}</h4>
    <p>{`You're storing configs in version control. In plaintext. They better not be secret 😉`}</p>
    <p>{`And you'll have to re-deploy any time you change a value.`}</p>
    <p>{`But hey at least it works.`}</p>
    <h2 {...{
      "id": "in-conclusion"
    }}>{`In conclusion`}</h2>
    <p>{`There's no perfect solution here yet, I'm afraid. The JSON approach combined with static queries seems best for now. If you've found something better, I'd love to know.`}</p>
    <p>{`Happy hacking ✌️`}</p>
    <p>{`Cheers,`}</p>
    <p>{`~Swizec`}</p>
    <p>{`PS: I like to use AWS SecretsManager on the backend for real secrets, maybe there's an API you could use from the browser 🤔`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      